"use client";

import { Dot, Instagram, Twitter, Youtube } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Form, FormControl, FormField, FormItem, FormMessage } from "@/components/ui/form";
import { Input } from "@/components/ui/input";
import { FormProvider, useWvcForm } from "@/integrations/forms/FormProvider";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
const programmeLinks = [{
  label: "Weight Loss",
  href: "/TheBlueprintPage"
}, {
  label: "Muscle Gain",
  href: "/TheBlueprintPage"
}, {
  label: "Online Coaching",
  href: "/TheBlueprintPage"
}, {
  label: "Performance",
  href: "/TheBlueprintPage"
}];
const fineLinks = [{
  label: "PRIVACY",
  href: "#"
}, {
  label: "TERMS",
  href: "#"
}, {
  label: "COLOPHON",
  href: "#"
}];
const socials = [{
  icon: Instagram,
  label: "Instagram",
  href: "#"
}, {
  icon: Twitter,
  label: "Twitter",
  href: "#"
}, {
  icon: Youtube,
  label: "Youtube",
  href: "#"
}];
const marqueeItems = ["PEAK FORCE", "INDUSTRIAL PERFORMANCE", "NO EXCUSES", "ENGINEERED RESULTS", "ELITE TRAINING"];
function NavigateLinks() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <ul className="space-y-3">
        {[0, 1, 2, 3, 4].map(i => <li key={i} data-index={i} className="h-5 w-32 bg-muted animate-pulse" />)}
      </ul>;
  }
  return <ul className="space-y-3">
      {menuItems.map((item, i) => <li data-index={i} key={item.id}>
          <Link to={item.href || "#"} className="font-default text-base text-muted-foreground hover:text-primary transition-colors group inline-block">
            <span className="border-b border-transparent group-hover:border-primary pb-0.5 transition-colors">
              {item.label}
            </span>
          </Link>
        </li>)}
    </ul>;
}
function NewsletterForm() {
  const {
    isSubmitting,
    isSubmitted,
    submitError,
    successMessage,
    handleSubmit,
    control
  } = useWvcForm();
  if (isSubmitted && !submitError) {
    return <p className="font-mono text-[11px] uppercase tracking-wider text-primary">
        {successMessage}
      </p>;
  }
  return <Form onSubmit={handleSubmit} className="space-y-3">
      <FormField control={control} name="email" rules={{
      required: "Email is required",
      pattern: {
        value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
        message: "Invalid email"
      }
    }} render={({
      field
    }) => <FormItem>
            <FormControl>
              <Input type="email" placeholder="ENTER YOUR EMAIL" className="h-10 border-0 border-b border-muted-steel bg-transparent px-0 font-mono text-xs uppercase tracking-wider text-foreground placeholder:text-muted-steel focus-visible:border-primary focus-visible:ring-0" {...field} />
            </FormControl>
            <FormMessage className="font-mono text-[10px] uppercase tracking-wider text-destructive" />
          </FormItem>} />
      <Button type="submit" variant="ghost" size="sm" disabled={isSubmitting} className="h-auto p-0 font-mono text-xs uppercase tracking-wider text-primary hover:bg-transparent hover:text-primary/80">
        {isSubmitting ? "SENDING..." : "→ JOIN FORCE"}
      </Button>
      {submitError && <p className="font-mono text-[10px] uppercase tracking-wider text-destructive">
          {submitError}
        </p>}
    </Form>;
}
export default function TheBasecamp() {
  return <section data-section-id="5151" id="the-basecamp" className="bg-background text-foreground pt-[120px] pb-10 overflow-hidden">
      <div className="mx-auto max-w-7xl px-6 md:px-10">
        {}
        <div className="relative mb-20">
          <h2 className="font-default font-black uppercase leading-none tracking-tighter text-foreground" style={{
          fontSize: "clamp(6rem, 18vw, 20rem)"
        }}>
            PEAK
          </h2>
          <div className="h-px w-full bg-primary" />
        </div>

        {}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-10 md:gap-8 mb-16">
          {}
          <div>
            <h3 className="font-default font-mono text-[11px] uppercase tracking-widest text-primary mb-6">
              NAVIGATE
            </h3>
            <MenuProvider menu_id="3">
              <NavigateLinks />
            </MenuProvider>
          </div>

          {}
          <div>
            <h3 className="font-default font-mono text-[11px] uppercase tracking-widest text-primary mb-6">
              PROGRAMS
            </h3>
            <ul className="space-y-3">
              {programmeLinks.map((item, i) => <li data-index={i} key={item.label}>
                  <Link to={item.href} className="font-default text-base text-muted-foreground hover:text-primary transition-colors group inline-block">
                    <span className="border-b border-transparent group-hover:border-primary pb-0.5 transition-colors">
                      {item.label}
                    </span>
                  </Link>
                </li>)}
            </ul>
          </div>

          {}
          <div>
            <h3 className="font-default font-mono text-[11px] uppercase tracking-widest text-primary mb-6">
              CONTACT
            </h3>
            <ul className="space-y-3 font-default text-muted-foreground">
              <li>Industrial District, Fitness City</li>
              <li>
                <Link to="tel:+15550001234" className="hover:text-primary transition-colors">
                  +1 (555) 000-1234
                </Link>
              </li>
              <li>
                <Link to="mailto:force@peakfitness.com" className="hover:text-primary transition-colors">
                  force@peakfitness.com
                </Link>
              </li>
              <li className="not-italic font-mono text-[11px] uppercase tracking-wider text-muted-foreground/70 pt-2">
                Mon–Sun: 05:00 AM – 11:00 PM
              </li>
            </ul>
          </div>

          {}
          <div className="col-span-2 md:col-span-1">
            <h3 className="font-default font-mono text-[11px] uppercase tracking-widest text-primary mb-6">
              DISPATCHES
            </h3>
            <p className="font-default text-sm text-muted-foreground mb-4 leading-relaxed">
              Elite training protocols and performance insights delivered weekly.
            </p>
            <FormProvider formKey="basecamp_form_home" formId="basecamp_form_home" sectionName="footer" defaultValues={{
            email: ""
          }} validationRules={{
            email: {
              required: true,
              pattern: "email"
            }
          }} submitText="SUBSCRIBE" successMessage="TRANSMISSION RECEIVED.">
              <NewsletterForm />
            </FormProvider>
          </div>
        </div>

        {}
        <div className="h-px w-full bg-border mb-8" />

        {}
        <div className="flex flex-col md:flex-row items-center justify-between gap-6 mb-10">
          {}
          <p className="font-mono text-[11px] uppercase tracking-wider text-muted-foreground order-2 md:order-1">
            © MMXXIV PEAK FORCE. ALL RIGHTS RESERVED.
          </p>

          {}
          <div className="flex items-center gap-5 order-1 md:order-2">
            {socials.map((social, i) => {
            const Icon = social.icon;
            return <Link data-index={i} key={social.label} to={social.href} newTab aria-label={social.label} className="text-muted-foreground hover:text-primary transition-colors">
                  <Icon className="size-4" strokeWidth={1.5} />
                </Link>;
          })}
          </div>

          {}
          <div className="flex items-center gap-1 order-3 font-mono text-[11px] uppercase tracking-wider">
            {fineLinks.map((link, i) => <div data-index={i} key={link.label} className="flex items-center gap-1">
                <Link to={link.href} className="text-muted-foreground hover:text-primary transition-colors">
                  {link.label}
                </Link>
                {i < fineLinks.length - 1 && <Dot className="size-3 text-primary" strokeWidth={4} />}
              </div>)}
          </div>
        </div>
      </div>

      {}
      <div className="relative w-full bg-primary overflow-hidden border-t border-primary">
        <div className="flex whitespace-nowrap animate-[marquee_40s_linear_infinite]">
          {[0, 1, 2, 3].map(loop => <div data-index={loop} key={loop} className="flex shrink-0 items-center">
              {marqueeItems.map((item, i) => <div data-index={i} key={`${loop}-${i}`} className="flex items-center font-mono text-xs uppercase tracking-widest text-primary-foreground py-3">
                  <span className="px-6">{item}</span>
                  <span className="text-primary-foreground">◉</span>
                </div>)}
            </div>)}
        </div>
      </div>

      <style>{`
        @keyframes marquee {
          0% { transform: translateX(0); }
          100% { transform: translateX(-25%); }
        }
      `}</style>
    </section>;
}